import React from 'react'
import { Row, Col, Button, Icon, Modal, Tooltip, Upload, Spin } from 'antd'
import 'src/core/utils/linq'
import { withTranslation, WithTranslation } from 'react-i18next'
import HttpService from "src/core/services/http.service"
import { resolve } from 'src/inversify.config'
import { withSize } from 'react-sizeme'
import "src/core/ui/collections/table.less"
import { expoirerrorNotification, infoNotification, successNotification } from '../systemNotifications/notificationService'

export interface ModalProps extends WithTranslation {
    bulkTemplateUrl?: string
    bulkInsertUrl?: string
    bulkTemplateName?: string,
    tooltipTitle?: string
}

export interface ModalState {
    uploadingError?: any,
    downloadModal: boolean,
    isBusy: boolean,
}

class Table<T> extends React.Component<ModalProps, ModalState> {

    constructor(props: ModalProps) {
        super(props)
        this.state = {
            downloadModal: false,
            isBusy: false,
        }
    }

    @resolve(HttpService)
    httpService!: HttpService

    downloadExcelTemplate = async () => {
        if (this.props.bulkTemplateUrl) {
            await this.httpService.get(this.props.bulkTemplateUrl, {
                responseType: 'arraybuffer'
            });
            this.setState({ isBusy: false });
            successNotification(this.props.t('Operation Completed Successfully'), this.props.t('Your operation will be processed in background.'));
        }
    }

    beforeExcelUpload = (file: File) => {
        const isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        if (!isExcel) {
            infoNotification(this.props.t('Info'), this.props.t('You can only upload Excel files!'));
        }
        return isExcel;
    };

    public render() {
        const { t } = this.props as any

        return <>
            <Row>
                <Col span={24}>
                    {this.props.bulkInsertUrl &&
                        <li><Tooltip title={this.props.tooltipTitle ? this.props.tooltipTitle:t('Bulk upload items')}>
                            <Button icon="upload" onClick={() => this.setState({ downloadModal: true })}>
                            </Button>
                        </Tooltip></li>
                    }

                    {this.props.bulkInsertUrl &&
                        <Spin spinning={this.state.isBusy} style={{ marginTop: -16 }}>
                            <Modal
                                title={t('Bulk upload')}
                                visible={this.state.downloadModal}
                                okButtonProps={{ style: { display: 'none' } }}
                                closable={false}
                                onCancel={() => { this.setState({ downloadModal: false }) }}
                                cancelText={t('Cancel')}
                            >
                                <h4 style={{ marginTop: '4px' }}>{t('Import template')}</h4>

                                <h5 style={{ marginTop: '4px' }}>{t('Use an excel template to easily import')}</h5>

                                <Button
                                    block
                                    color={'#40a9ff'}
                                    onClick={() => {
                                        this.downloadExcelTemplate()
                                        this.setState({ downloadModal: false, isBusy: true })
                                    }
                                    }>
                                    <Icon type="download" />
                                    {t('download import template')}
                                </ Button>

                                <h5 style={{ marginTop: '15px' }}>{t('We help you import your information in an agile way')}</h5>
                                {this.props.bulkInsertUrl && <li><Upload.Dragger
                                    name="file"
                                    headers={{
                                        authorization: `Bearer ${HttpService.accessToken}`,
                                        language: `${HttpService.language}`
                                    }}
                                    showUploadList={false}
                                    action={this.props.bulkInsertUrl}
                                    beforeUpload={this.beforeExcelUpload}
                                    onChange={info => {
                                        const { file } = info;
                                        const { status, response } = file;

                                        if (status === 'uploading') {
                                            this.setState({ downloadModal: false, isBusy: true });
                                        } else if (status === 'error') {
                                            this.setState({ downloadModal: false, isBusy: false });
                                            const errorMessage = response?.error?.message || (response?.messages?.length > 0 && response.messages.map((i: any) => i.body).join(","));
                                            expoirerrorNotification(this.props.t('Error'), errorMessage || 'Unknown error');
                                        } else if (status === 'done') {
                                            this.setState({ downloadModal: false, isBusy: false });
                                            successNotification(this.props.t('Operation Completed Successfully'), this.props.t('Your operation will be processed in background.'));
                                        } else {
                                            this.setState({ downloadModal: false, isBusy: false });
                                        }
                                    }}>
                                    <p className="ant-upload-text">{t('Click or drag file to this area to upload')}</p>
                                    <p className="ant-upload-drag-icon">
                                        <Icon type="inbox" />
                                    </p>

                                </Upload.Dragger></li>}
                            </Modal>
                        </Spin>
                    }
                </Col>
            </Row>
        </>
    }
}

export const BulkInsertUpload = withTranslation()(withSize()(Table)) as any

